import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { computed, ref, watch, type PropType } from 'vue';

import { DivTableColumn, divTableSortDirections } from './div-table-helpers';
import DivTableCell from './DivTableCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DivTableHeader',
  props: {
  stickyHeader: { type: Boolean, default: false },
  value: { type: Array as PropType<Array<DivTableColumn<unknown>>>, required: true },
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const internalColumns = ref(props.value);
const columnsToShow = computed(() => internalColumns.value.filter((i) => !i.hidden));

watch(
  () => props.value,
  () => {
    internalColumns.value = props.value;
  },
);

const sort = (column: DivTableColumn<unknown>) => {
  if (!column.sortable) return; // Don't sort if the column is not sortable

  emit(
    'input',
    internalColumns.value.map((val) => {
      if (val !== column) {
        // eslint-disable-next-line no-param-reassign
        val.sorted = false;

        return val;
      }

      if (val.sorted === true) {
        // eslint-disable-next-line no-param-reassign
        val.sortDirection = val.sortDirection === divTableSortDirections.asc ? divTableSortDirections.desc : divTableSortDirections.asc;
      } else {
        // eslint-disable-next-line no-param-reassign
        val.sorted = true;
      }

      return val;
    }),
  );
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['div-table-header', { 'div-table-header--sticky-header': __props.stickyHeader }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnsToShow.value, (column, index) => {
      return (_openBlock(), _createBlock(DivTableCell, {
        key: index,
        sortable: column.sortable && column.sortFunction,
        class: _normalizeClass(['div-table-header__cell', column.columnClass, column.title.trim().length == 0 ? 'empty' : '']),
        onClick: ($event: any) => (sort(column))
      }, {
        default: _withCtx(() => [
          (column.title)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([`div-table-header__title`, { sorted: column.sorted }])
              }, _toDisplayString(column.title), 3))
            : _createCommentVNode("", true),
          (column.sortable)
            ? (_openBlock(), _createBlock(_component_ot_icon, {
                key: 1,
                class: _normalizeClass(["sort-icon", { [column.sortDirection]: true, sorted: column.sorted }]),
                "inherit-stroke": true,
                name: column.sorted ? 'full-arrow-up' : 'arrow-3'
              }, null, 8, ["name", "class"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["sortable", "class", "onClick"]))
    }), 128))
  ], 2))
}
}

})